import { observer } from 'mobx-react-lite';
import moment from 'moment';
import { IonSlides, IonSlide, IonText, IonButton } from '@ionic/react';

import workoutAssignmentStore from 'stores/workout-assignment.store';

import WorkoutInfoContainer from './components/WorkoutInfoContainer';
import Loader from './components/WorkoutInfoContainer/Loader';

import { sliderConfig } from 'config.json';
import classes from './style.module.scss';

const ExerciseWorkouts = ({ match, history }) => {
  const workoutAssignments = workoutAssignmentStore.getObjects();
  const isLoading = workoutAssignmentStore.getIsLoading();
  const selectedDate = moment();

  const getWorkoutAssignmentUrl = (workoutAssignment) => {
    const workoutAssignmentId = workoutAssignment.id;
    const workoutName = workoutAssignment.workout.name;
    return `/workouts/${workoutAssignmentId}?name=${workoutName}`;
  };

  return (
    <div className={classes.mainContainer}>
      <div className={classes.title}>
        <IonText className='big'>{"Today's Workouts"}</IonText>
        <IonButton
          onClick={() => history.push('/workouts')}
          fill='clear'
          size='small'
        >
          <IonText className='small'>View All</IonText>
        </IonButton>
      </div>
      <div className={classes.content}>
        {!isLoading ? (
          workoutAssignments.length > 0 ? (
            <IonSlides options={sliderConfig}>
              {workoutAssignments.map((workoutAssignment, index) => (
                <IonSlide
                  className={classes.ionSlide}
                  key={workoutAssignment.id}
                >
                  <div
                    className={classes.ExerciseWorkoutContainer}
                    onClick={(e) => {
                      e.stopPropagation();
                      history.push(getWorkoutAssignmentUrl(workoutAssignment));
                    }}
                  >
                    <WorkoutInfoContainer
                      workoutAssignment={workoutAssignment}
                    />
                  </div>
                </IonSlide>
              ))}
            </IonSlides>
          ) : (
            'No Data available'
          )
        ) : (
          <div className={classes.ExerciseWorkoutContainer}>
            <Loader />
          </div>
        )}
      </div>
    </div>
  );
};

export default observer(ExerciseWorkouts);
